import formatPrice from './formatPrice'

const getTotalAmountPaid = array => {
    let result = array.reduce((sum, item) => item ? item.total + sum : sum, 0).toFixed(2).toString();
    return formatPrice(result)
}

export default getTotalAmountPaid